import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('WAREHOUSES', ['HEADER'])
